import { Entity, Lex, QuotePro, QuoteProViewFilters } from '../';

export enum QuoteProViewVisibility {
    Private = 'Private',
    Public = 'Public',
    Shared = 'Shared'
}

export enum QuoteProViewDisplayType {
    Kanban = 'Kanban',
    Grid = 'Grid'
}

export type QuoteProViewSortType = 'ASC' | 'DESC';

export enum QuoteProViewSortBy {
    None = 'none',
    Name = 'name',
    CreatedAt = 'createdAt',
    QuoteDate = 'date',
    ExpiryDate = 'expiryDate',
}

export interface QuoteProViewSortOptions {
    sortBy: QuoteProViewSortBy;
    sortType: QuoteProViewSortType;
}

export interface QuoteProViewSummary {
    _id: string;
    name: string;
    visibility: QuoteProViewVisibility;
    displayType: QuoteProViewDisplayType;
    sort?: QuoteProViewSortOptions;
    card: QuoteProViewCardFields,
    list: QuoteProViewListField[];
    isDefault: boolean;
    system: boolean;
    selected: boolean;
    ownerId?: string;
    canEditView?: boolean;
    sharedWith: Entity[]
    filters?: QuoteProViewFilters;
}

export interface QuoteProViewCardFields {
    // quoteNumber: boolean;

    name: boolean;
    links: boolean; // related to

    acceptor: boolean;
    approver: boolean;

    customerRef: boolean;
    account: boolean;
    address: boolean;
    owner: boolean;
    jobType: boolean;

    date: boolean; // quote date
    expiryDate: boolean;
    createdAt: boolean;
}


export interface QuoteProViewListField {
    _id: keyof QuotePro;
    name: string;
    visible: boolean;
    sortOrder?: Lex;
    system: boolean;
}


export const DefaultQuoteProFields: QuoteProViewListField[] = [
    { _id: 'quoteNumber', name: 'Quote Number', visible: true, system: true },
    { _id: 'links', name: 'Related To', visible: true, system: true },
    { _id: 'name', name: 'Name', visible: true, system: true },
    { _id: 'status', name: 'Status', visible: true, system: true },

    { _id: 'acceptor', name: 'Acceptor', visible: false, system: true },
    { _id: 'approver', name: 'Approver', visible: false, system: true },

    { _id: 'customerRef', name: 'Customer Reference', visible: false, system: true },
    { _id: 'account', name: 'Customer Account', visible: true, system: true },
    { _id: 'address', name: 'Address', visible: true, system: true },
    { _id: 'owner', name: 'Owner', visible: true, system: true },
    { _id: 'jobType', name: 'Job Type', visible: false, system: true },

    { _id: 'date', name: 'Quote Date', visible: true, system: true },
    { _id: 'expiryDate', name: 'Expiry Date', visible: true, system: true },
    { _id: 'createdAt', name: 'Created Date', visible: false, system: true },
];

export interface QuoteProView extends Entity {

    description: string;
    displayType?: QuoteProViewDisplayType;
    visibility?: QuoteProViewVisibility;
    sharedWith?: Entity[];

    owner: Entity;
    system?: boolean;

    filters: QuoteProViewFilters;
    card: QuoteProViewCardFields;
    list: QuoteProViewListField[];

    canEditView?: boolean;
    canShareView?: boolean;

    sort?: QuoteProViewSortOptions;

}

export const DefaultQuoteProViewCards: QuoteProViewCardFields = {
    name: true,
    links: true,

    acceptor: false,
    approver: false,

    account: true,
    customerRef: false,
    address: true,
    owner: true,
    jobType: false,

    date: true,
    expiryDate: true,
    createdAt: false,
};

export const emptyQuoteProView = (data?: Partial<QuoteProView>): QuoteProView => {
    return {
        name: null,
        description: null,
        displayType: QuoteProViewDisplayType.Kanban,
        visibility: QuoteProViewVisibility.Private,
        sharedWith: [],
        filters: {},
        card: { ...DefaultQuoteProViewCards },
        list: [...DefaultQuoteProFields],
        ...data,
    } as QuoteProView;
}
